// extracted by mini-css-extract-plugin
export var blue = "_4b-g";
export var brand = "_4b-c";
export var darkGrey = "_4b-f";
export var disabled = "_4b-5";
export var disabledSubtle = "_4b-6";
export var error = "_4b-7";
export var green = "_4b-h";
export var grey = "_4b-e";
export var icon = "_4b-0";
export var inherit = "_4b-b";
export var lightGrey = "_4b-d";
export var orange = "_4b-j";
export var pink = "_4b-l";
export var primary = "_4b-1";
export var purple = "_4b-m";
export var quaternary = "_4b-4";
export var red = "_4b-k";
export var secondary = "_4b-2";
export var success = "_4b-a";
export var tertiary = "_4b-3";
export var warning = "_4b-8";
export var warningSecondary = "_4b-9";
export var white = "_4b-n";
export var yellow = "_4b-i";